import { TODAY, PHASES } from '../constants/config';

export const uid       = ()     => Math.random().toString(36).slice(2, 9);
export const daysAgo   = d      => Math.floor((TODAY - new Date(d)) / 86400000);
export const daysUntil = d      => Math.floor((new Date(d) - TODAY) / 86400000);
export const hoursW    = (b, r) => r > 0 ? Math.round(b / r) : 0;
export const fmtMoney  = v      => v >= 1e6 ? `${(v / 1e6).toFixed(1)}M kr` : v >= 1e3 ? `${(v / 1e3).toFixed(0)}K kr` : `${v} kr`;
export const getInit   = n      => String(typeof n === "string" ? n : n?.name || n?.author || "").split(" ").filter(Boolean).map(x => x[0]).join("").toUpperCase().slice(0, 2);
export const relTime   = iso    => {
  const d = daysAgo(iso);
  return d === 0 ? "Today" : d === 1 ? "Yesterday" : d < 7 ? `${d}d ago`
    : new Date(iso).toLocaleDateString("en-GB", { day:"numeric", month:"short" });
};

export const priorityLabel = s => s >= 55 ? "P1" : s >= 28 ? "P2" : "P3";

export function projectPriority(p) {
  let s = 0;
  if (p.projectStatus === "Critical") s += 45; else if (p.projectStatus === "At Risk") s += 22;
  // Only score NPS when we actually have data. NPS is on a 0-5 scale
  // (Monday WBR source), so low-satisfaction bands sit at <3 and <3.75.
  // Null/undefined means no project override and no client value —
  // don't contribute to the priority score in that case.
  if (typeof p.NPS === "number" && p.NPS > 0) {
    if (p.NPS < 3) s += 28; else if (p.NPS < 3.75) s += 12;
  }
  const dEnd = daysUntil(p.contractEndDate);
  if (dEnd < 30) s += 32; else if (dEnd < 60) s += 16;
  if (p.weeklyReportStatus === "Overdue") s += 22;
  if (p.profitPct < 15) s += 18;
  if (p.utilizationPct < 60) s += 10;
  return s;
}

export function computeUrgency(task, project) {
  let s = 0;
  const due = daysUntil(task.dueDate);
  if (due < 0) s += 50; else if (due <= 1) s += 35; else if (due <= 3) s += 24;
  else if (due <= 7) s += 15; else if (due <= 14) s += 8;
  s += ({ Critical:30, High:18, Medium:8, Low:2 }[task.priority] || 0);
  s += ({ Escalated:35, VIP:24, Strategic:14, Standard:4 }[task.customerPriority] || 0);
  if (task.status === "Blocked") s += 25;
  else if (task.status === "Waiting on Internal") s += 12;
  else if (task.status === "Waiting on Client") s += 8;
  if (project?.projectStatus === "Critical") s += 15; else if (project?.projectStatus === "At Risk") s += 8;
  return Math.min(s, 100);
}

export function withUrgency(tasks, projects) {
  const pMap = Object.fromEntries(projects.map(p => [p.projectId, p]));
  return tasks.map(t => ({ ...t, urgencyScore: computeUrgency(t, pMap[t.projectId]) }));
}

export function getPhaseProgress(tasks) {
  return PHASES.map(ph => {
    const pt   = tasks.filter(t => t.phaseId === ph.id && t.status !== "Cancelled");
    const done = pt.filter(t => t.status === "Done").length;
    return { ...ph, total:pt.length, done, pct: pt.length ? Math.round((done / pt.length) * 100) : 0 };
  }).filter(p => p.total > 0);
}

export function getDeptSummary(tasks) {
  const map = {};
  tasks.filter(t => t.status !== "Done" && t.status !== "Cancelled").forEach(t => {
    if (!map[t.department]) map[t.department] = { open:0, overdue:0, blocked:0 };
    map[t.department].open++;
    if (daysUntil(t.dueDate) < 0) map[t.department].overdue++;
    if (t.status === "Blocked") map[t.department].blocked++;
  });
  return map;
}
